import { useSession } from "next-auth/react";
import { getAccount, updateUser } from "utils/sessionHelper";
import * as Sentry from "@sentry/nextjs";
import { useFirebaseUser } from "../utils/useFirebaseUser";

type StatAction =
  | "auto_dm"
  | "access_engage"
  | "search_via_search_page"
  | "search_via_auto_page"
  | "add_to_queue"
  | "schedule_post"
  | "post_now"
  | "visit_queue_ghostwriters"
  | "access_analytics";

export function useStats() {
  const { data: session } = useSession() ?? {}
  const isAuthenticated = useFirebaseUser();

  async function updateStatsCounter(action: StatAction) {
    try {
      if (!isAuthenticated) {
        console.error("couldn't update stats counter: not authenticated");
      }

      const counterKey = `counter_${action}`;
      const stats = getAccount(session)?.stats ?? {};
      const newCounter = stats[counterKey] ?? 0;

      await updateUser(session, {
        stats: { ...stats, [`counter_${action}`]: newCounter + 1 },
      });
    } catch (e) {
      console.log(e);
      Sentry.captureException(e);
    }
  }

  return { updateStatsCounter };
}
